import { createDashboardIdsWithSuffix } from 'src/Libs/dashboard/routes'

export const SYSTEM_STATUS_BASE_URL = '/dashboard/system-status'

/** Route path of the system protocol tab, relative to the system status page */
export const SYSTEM_PROTOCOL_TAB_PATH = 'protocol'

/** Route paths of all tabs of the system status page */
export const SYSTEM_STATUS_TAB_PATHS = [SYSTEM_PROTOCOL_TAB_PATH]

/**
 * Creates the URL of the system status page, which redirects to its first tab.
 */
export const getSystemStatusUrl = (installationId?: number | string, storageId?: string | null): string =>
  createDashboardIdsWithSuffix(SYSTEM_STATUS_BASE_URL, installationId, storageId)

/**
 * Creates the URL of the system protocol tab of the system status page.
 */
export const getSystemProtocolUrl = (installationId: number | string, storageId?: string | null): string =>
  `${getSystemStatusUrl(installationId, storageId)}/${SYSTEM_PROTOCOL_TAB_PATH}`
